import fetchApi from "../fetchApi";
export const GetProgramReportTypes = async (program) => {
  try {
    const options = {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
      }),
      redirect: "follow",
    };

    return await fetchApi(
      `card-issuing/company/program-report/${program}/config`,
      options
    );
  } catch (error) {
    console.error("Error fetching report types:", error);
    throw error;
  }
};
